import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

export default function AcabamentoTabelaParadas({ data }) {
    return (
        <div className="p-m-2">
            <h3 className="p-m-1">Tempos de Parada</h3>
            <h4 className="p-m-1">Total: {String(parseInt(data.total / 60)).padStart(2, '0')}:{String(parseInt(data.total % 60)).padStart(2, '0')}</h4>
            <DataTable 
                responsiveLayout="scroll"
                size="small"
                value={data.paradas}
            >
                <Column header="Parada" field="parada" sortable />
                <Column header="Tempo Parado (horas)" field="horaformatada" />
                <Column header="Tempo Parado (minutos)" sortable field="minutos"/>
                <Column header="%" sortable field="percentual" />
            </DataTable>
        </div>
    )
}